// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as loadProjectDetailCustomComponentReducer } from './loadProjectDetailCustomComponent';
import { reducer as addCustomComponentConfigReducer } from './addCustomComponentConfig';
import { reducer as loadCustomComponentConfigsReducer } from './loadCustomComponentConfigs';
import { reducer as deleteCustomComponentConfigReducer } from './deleteCustomComponentConfig';
import { reducer as updateCustomComponentConfigReducer } from './updateCustomComponentConfig';
import { reducer as addCustomComponentCssCdnReducer } from './addCustomComponentCssCdn';
import { reducer as deleteCustomComponentCssCdnReducer } from './deleteCustomComponentCssCdn';
import { reducer as updateCustomComponentCssCdnReducer } from './updateCustomComponentCssCdn';
import { reducer as addCustomComponentJsCdnReducer } from './addCustomComponentJsCdn';
import { reducer as deleteCustomComponentJsCdnReducer } from './deleteCustomComponentJsCdn';
import { reducer as updateCustomComponentJsCdnReducer } from './updateCustomComponentJsCdn';
import { reducer as addCustomDataMappingReducer } from './addCustomDataMapping';
import { reducer as loadCustomDataMappingReducer } from './loadCustomDataMapping';
import { reducer as deleteCustomDataMappingReducer } from './deleteCustomDataMapping';
import { reducer as updateCustomDataMappingReducer } from './updateCustomDataMapping';
import { reducer as loadCustomComponentConfigReducer } from './loadCustomComponentConfig';
import { reducer as cloneCustomComponentReducer } from './cloneCustomComponent';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
import { reducer as cloneCustomDataMappingReducer } from './cloneCustomDataMapping';
import { reducer as deleteCustomFunctionReducer } from './deleteCustomFunction';
import { reducer as loadCustomFunctionConfigReducer } from './loadCustomFunctionConfig';
import { reducer as loadCustomFunctionDetailReducer } from './loadCustomFunctionDetail';
import { reducer as updateCustomFunctionReducer } from './updateCustomFunction';
import { reducer as addCustomFunctionReducer } from './addCustomFunction';
import { reducer as customFunctionExecutionReducer } from './customFunctionExecution';
import { reducer as customFunctionLogsReducer } from './customFunctionLogs';
import { reducer as cloneCustomFunctionReducer } from './cloneCustomFunction';
import { reducer as generateCustomComponentReducer } from './generateCustomComponent';

const reducers = [
  loadProjectDetailCustomComponentReducer,
  addCustomComponentConfigReducer,
  loadCustomComponentConfigsReducer,
  deleteCustomComponentConfigReducer,
  updateCustomComponentConfigReducer,
  addCustomComponentCssCdnReducer,
  deleteCustomComponentCssCdnReducer,
  updateCustomComponentCssCdnReducer,
  addCustomComponentJsCdnReducer,
  deleteCustomComponentJsCdnReducer,
  updateCustomComponentJsCdnReducer,
  addCustomDataMappingReducer,
  loadCustomDataMappingReducer,
  deleteCustomDataMappingReducer,
  updateCustomDataMappingReducer,
  loadCustomComponentConfigReducer,
  cloneCustomComponentReducer,
  getPermissionFlagsReducer,
  cloneCustomDataMappingReducer,
  deleteCustomFunctionReducer,
  loadCustomFunctionConfigReducer,
  loadCustomFunctionDetailReducer,
  updateCustomFunctionReducer,
  addCustomFunctionReducer,
  customFunctionExecutionReducer,
  customFunctionLogsReducer,
  cloneCustomFunctionReducer,
  generateCustomComponentReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
